import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-task-reminder',
  templateUrl: './task-reminder.component.html',
  styleUrls: ['./task-reminder.component.scss']
})
export class TaskReminderComponent implements OnInit {

  @Output() closeAssignedTask = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  close(){
    this.closeAssignedTask.emit(false)
  }
}
